import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const ContentContainer = styled.div`
  max-width: 100%;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Card = styled.form`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  background: #fff;
  border-radius: 0.25rem;
  -webkit-box-shadow: 0 0 35px 0 rgb(154 161 171 / 15%);
  box-shadow: 0 0 35px 0 rgb(154 161 171 / 15%);

  @media (max-width: 992px) {
    padding: 10px;
  }
`;

export const Address = styled.div`
  display: flex;
  padding: 10px 0;
  flex: ${(props) => props.flex};
  justify-content: space-between;
  border-bottom: 1px solid #eee;
  button {
    width: 10px;
  }

  svg {
    display: flex;
    width: 10px;
  }

  @media (max-width: 992px) {
    font-size: 16px;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 10px;
  width: 100%;
  padding-top: 20px;

  @media (max-width: 992px) {
    padding-top: 10px;
  }

  &:first-child {
    padding-top: 0px;
  }
`;

export const Trash = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
  width: auto;
  height: auto;
  flex: 1;

  @media (max-width: 768px) {
    display: none;
    flex: 0.2;
  }
`;
export const OptionsArea = styled.div`
  display: none;
  justify-content: center;
  align-items: center;

  svg {
    width: 25px;
    height: 25px;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const Box = styled.div`
  display: flex;
  flex: 1;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const Area = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  flex: ${(props) => props.flex};
  padding: 0 5px;
  margin-bottom: 1rem;
  color: ${(props) => props.theme.colors.grayDark};

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Check = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Tool = styled.div`
  padding: 20px 10px 0 0;
`;

export const CheckBoxArea = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CheckBoxWrapper = styled.div`
  position: relative;
`;
export const CheckBoxLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  width: 42px;
  height: 26px;
  border-radius: 15px;
  background: #bebebe;
  cursor: pointer;
  &::after {
    content: '';
    display: block;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    margin: 3px;
    background: #ffffff;
    box-shadow: 1px 3px 3px 1px rgba(0, 0, 0, 0.2);
    transition: 0.2s;
  }
`;

export const CheckBox = styled.input`
  opacity: 0;
  z-index: 1;
  border-radius: 15px;
  width: 42px;
  height: 26px;
  &:checked + ${CheckBoxLabel} {
    background: #4db6ac;
    &::after {
      content: '';
      display: block;
      border-radius: 50%;
      width: 18px;
      height: 18px;
      margin-left: 21px;
      transition: 0.2s;
    }
  }
`;

export const StatusArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Status = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Header = styled.div`
  display: flex;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  padding: 12px 0;
  div {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const WithOutAddress = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding-top: 20px;
`;

export const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  padding: 20px 0;
`;

export const ButtonPlus = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-size: 1.15rem;
  line-height: 1.5;
  background: ${(props) => props.theme.colors.greenDark};
  box-shadow: 0px 3px 4px #00000050;
  transition: box-shadow 0.6s, background 0.6s;
  color: #fff;
  font-weight: bold;
  border-radius: 0.25rem;
  padding: 0.45rem 0.9rem;
  border: 0;

  &:hover {
    background: ${(props) => props.theme.colors.greenMedium};
    box-shadow: 2px 6px 8px #00000050;
  }

  svg {
    display: flex;
    font-size: 20px;
    margin-right: 20px;
  }
`;

export const SubmitButton = styled.button.attrs({ type: 'submit' })`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  font-size: 1.15rem;
  line-height: 1.5;
  background: ${(props) => props.theme.colors.greenDark};
  box-shadow: 0px 3px 4px #00000050;
  transition: box-shadow 0.6s, background 0.6s;
  color: #fff;
  font-weight: bold;
  border-radius: 0.25rem;
  padding: 0.45rem 0.9rem;
  border: 0;
  margin-left: 5px;

  &:hover {
    background: ${(props) => props.theme.colors.greenMedium};
    box-shadow: 2px 6px 8px #00000050;
  }

  svg {
    margin-left: 25px;
  }
`;

export const ButtonCancel = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50%;
  font-size: 1.15rem;
  line-height: 1.5;
  background: ${(props) => props.theme.colors.redDark};
  box-shadow: 0px 3px 4px #00000050;
  transition: box-shadow 0.6s, background 0.6s;
  color: #fff;
  font-weight: bold;
  border-radius: 0.25rem;
  padding: 0.45rem 0.9rem;
  border: 0;
  margin-right: 5px;

  &:hover {
    background: ${(props) => props.theme.colors.redLight};
    box-shadow: 2px 6px 8px #00000050;
  }
`;

export const Cep = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  flex: 1;
`;
export const Street = styled(Cep)`
  flex: 2;
`;
export const HomeNumb = styled(Cep)``;
export const Neighborhood = styled(Cep)`
  flex: 2;

  @media (max-width: 576px) {
    display: none !important;
  }
`;
export const City = styled(Cep)`
  @media (max-width: 576px) {
    display: none !important;
  }
`;
export const State = styled(Cep)`
  @media (max-width: 576px) {
    display: none !important;
  }
`;

export const ForceChangePassword = styled(Cep)`
  display: flex;
  flex-direction: column;
`;
